<template>
	<div style="background: white">
		<EducationHeader />
		<div class="breadBox">
			<a-breadcrumb>
				<span>
					<img src="@/assets/img/position.png" />
					当前位置：
				</span>
				<a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
				<a-breadcrumb-item @click="onRollback" style="cursor:pointer">人才政策</a-breadcrumb-item>
				<a-breadcrumb-item>人才政策详情</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div id="print" class="tabBox">
			<div class="title">{{ noticeObj.titleName }}</div>
			<div class="subtitle">
				<span>联系人:{{ noticeObj.contactPerson }}</span>
				<span> 发布日期:{{ noticeObj.releaseTime }}</span>
				<span onselectstart="return false;"> 字体: <span style="cursor: pointer;margin:0" @click="sizes++">【放大】</span><span style="cursor: pointer;margin:0" @click="sizes--">【缩小】</span><span style="cursor: pointer;margin:0" @click="sizes=16">【标准】</span>
				<PrintOn></PrintOn>
			</span>
			</div>
			<a-button style="margin-top: 10px;" type="primary" @click="onApply(noticeObj.id)"
				v-if="noticeObj.isApplication == 0 && isUserCode">发起申请</a-button>

			<div class="titlecontent" :style="{ fontSize: sizes + 'px' }" v-html="noticeObj.abstractNote"></div>
			<div class="content" :style="{ fontSize: sizes + 'px' }" v-html="noticeObj.content"></div>
		</div>
	</div>
</template>
<script>
import { message } from 'ant-design-vue';
import EducationHeader from './educationHeader';
import { homeEducationInfo } from "@/api/educationService";

export default {
	name: "noticeDetail",
	components: { EducationHeader },
	data() {
		return {
      sizes:16,
			noticeObj: {},
			isUserCode: false
		}
	},
	methods: {
		getDetail() {
			this.getAction({
				url: homeEducationInfo.talentpolicyDetail,
				params: { id: this.$route.query.id }
			}).then(res => {
				this.noticeObj = res
			})
		},
		onApply(id) {
			this.postAction({
				url: homeEducationInfo.applyTalentPolicy,
				params: { subsidyArticlesId: id }
			}).then(res => {
				if (res) {
					message.success('申请成功！')
				}
			})
		},
		onRollback() {
			this.$router.push({
				path: "/educationService/components/talentpolicy",
				query: {
					type: "人才政策",
				}
			})
		},
		onRollbackHome() {
			this.$router.push({
				path: "/educationService/index",
				query: {
					type: "首页"
				}
			})
		}
	},
	mounted() {
		this.getDetail()
		this.isUserCode = this.$ls.get("roleCode").includes('user')
	}
}
</script>
<style lang="less" scoped>
.breadBox {
	width: 1200px;
	margin: 0 auto;
	padding: 20px 0;
	background: white;
}

.tabBox {
	width: 1200px;
	margin: 0 auto;
	padding: 10px 0 20px 0;

	.title {
		text-align: center;
		font-size: 30px;
		color: #333;
	}

	.subtitle {
		font-size: 14px;
		margin-top: 30px;
		padding-bottom: 20px;
		color: #333;
		border-bottom: 1px solid #ccc;
		display: flex;
		justify-content: center;

		span {
			margin: 0 20px;
		}
	}

	.titlecontent {
		text-align: center;
		font-size: 16px;
		margin-top: 60px;
		font-weight: 600;
    padding:0 10%;
    line-height: 40px;
}
.content{
    padding:0 10%;
    font-size: 16px;
    line-height: 30px;
    margin-top: 60px;
    text-indent: 30px;
    :deep(img){
        width:60%;
        margin-left: 18%;
        margin-bottom: 20px;
    }
    :deep(p){
        line-height: 40px;
    }
}
}
</style>
